/* -------------------------- */
/* Theme custom JavaScript.   */
/* -------------------------- */

!function($) {

    // Document ready
    $(function() {

         // Only call these functions on product page
        if ( $('html').hasClass('template-product') ){

            // Re-arrange product info to tabs on product page
            productTabs();

        }


    });

   function productTabs() {
  
    // Create variables for tabs content
    $features = $('.tabs-content #tab1').children();
    $materials = $('.tabs-content #tab2').children();
    $size = $('.tabs-content #tab3').children();
    
    // Some products don't have instructions
    if ( $('.tabs-content #tab4').length > 0 ) {
        $instructions = $('.tabs-content #tab4').children();
        $('.tab-instructions .tab-content__inner').append($instructions);
    } else {
        $('.tab-instructions').remove();
    }
    
    // Add content to new tabs
    $('.tab-features .tab-content__inner').append($features);
    $('.tab-materials .tab-content__inner').append($materials);
    $('.tab-size .tab-content__inner').append($size);
    
    // Description as tab is optionary 
    if ( $('.tab-description').length > 0 ) {
        $description = $('.product__description').children().not('.tabs,.tabs-content,h2');
        $('.tab-description .tab-content__inner').append($description);
        $('.product__description').remove();
    } else {
        $('.product__description .tabs, .product__description .tabs-content').remove();
        $('.product__description').removeClass('hidden');
    }
    
    // Add heights for tabs and collapse them
    $('.tab-content').each( function() {
        var height = $(this).outerHeight();
        $(this).data('height', height);
        $(this).css('height', 0);
    });
    
    // Show and hide tabs content on click. 
    $('.description-tabs .tab h3').click( function() {
    
        var $currentTab = $(this).parent();
        
        if ($currentTab.hasClass('active')) {
            $currentTab.toggleClass('active').find('.tab-content').css('height', 0);
        } else {
            var height = $currentTab.find('.tab-content').data('height');
            $currentTab.toggleClass('active').find('.tab-content').css('height', height + 'px');
        }
    
    });

  }

}(jQuery);